<template>
  <ContentBox title="区域编辑器" style="margin:16px">
    <el-form ref="form" label-width="100px" label-position="left">
      <el-row>
        <el-col :span="16">
          <el-form-item label="区域选择">
            <CommonSelectPannel
              ref="regionPannel"
              v-model="rightData"
              :reverse="true"
              :leftData="leftData"
              :selectPanelColumns="['省份', '城市']"
              selectPlaceholder="请输入关键词"
            >
              <template slot="extraBtn">
                <PopBatchAdd
                  ref="popBatchAdd"
                  class="extra-item"
                  btn-name="批量添加区域"
                  label="省份城市"
                  placeholder="不同省、市或区通过英文逗号、空格或顿号隔开，支持城市级别精准输入"
                  @save-add="saveBatchAddArea"
                ></PopBatchAdd>
              </template>
            </CommonSelectPannel>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="省份">
            <span>{{ provinceText }}</span>
            <el-button
              v-show="provinceText !== ''"
              class="copy-btn"
              type="primary"
              size="mini"
              plain
              @click="copyToClipBoard(provinceText)"
            >复制</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="城市">
            <span>{{ cityText }}</span>
            <el-button
              v-show="cityText !== ''"
              class="copy-btn"
              type="primary"
              size="mini"
              plain
              @click="copyToClipBoard(cityText)"
            >复制</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </ContentBox>
</template>

<script>
import CommonSelectPannel from '@/components/scheduleDirection/CommonSelectPannel'
import PopBatchAdd from '@/components/common/PopBatchAdd'
import { buildRegionData } from '@/components/schedule/utils'

export default {
  components: {
    CommonSelectPannel,
    PopBatchAdd
  },
  data() {
    return {
      leftData: [],
      rightData: [],
      provinceText: '',
      cityText: ''
    }
  },
  watch: {
    rightData: {
      handler(val) {
        this.joinRegionNames()
      },
      deep: true
    }
  },
  created() {
    this.getRegionData()
  },
  methods: {
    getRegionData() {
      this.$service.getRegions().then((res) => {
        this.leftData = buildRegionData(res.regionList)
      })
    },
    saveBatchAddArea(value) {
      let values = (value || '').replace(/[,、\s]/g, ',').split(',')
      if (values.length === 0) {
        return
      }
      values = Array.from(new Set(values))
      let illegalValues = [...values]
      const addRegions = []
      this.leftData.forEach((item) => {
        if (values.indexOf(item.label) > -1) {
          addRegions.push(item)
          illegalValues = illegalValues.filter(val => val !== item.label)
        } else if (item.children) {
          item.children.forEach((e) => {
            if (values.indexOf(e.label) > -1) {
              addRegions.push(e)
              illegalValues = illegalValues.filter(val => val !== e.label)
            }
          })
        }
      })
      if (illegalValues.length > 0) {
        this.$message.error(`存在不正确的省份或城市：${illegalValues.join('、')}，请检查！`)
        return
      }
      const newValues = this.rightData.map((item) => item.value)
      addRegions.forEach((item) => {
        if (newValues.indexOf(item.value) === -1) {
          this.rightData.push(item)
          this.$refs.regionPannel.$children[0].handleSelectNode(item)
        }
      })
      this.$refs.popBatchAdd.batchAddOpen = false
    },
    joinRegionNames() {
      let provinceArr = []
      let cityArr = []

      this.rightData.forEach((item) => {
        if (item.children && item.children.length) {
          provinceArr.push(item.label)
        } else {
          cityArr.push(item.label)
        }
      })

      this.provinceText = provinceArr.join(',')
      this.cityText = cityArr.join(',')
    },
    copyToClipBoard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制到剪贴板')
        })
      } else {
        const input = document.createElement('input')
        input.setAttribute('readonly', 'readonly')
        input.value = text
        document.body.appendChild(input)
        input.setSelectionRange(0, 99)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('已复制到剪贴板')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.extra-item
  margin-left 10px
  padding 0 10px
.copy-btn
  margin-left 20px
</style>
